import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'task-setting-modal-app',
      templateUrl: './a-mailtask-show-modal.component.html',
      styleUrls: ['mail.component.css']
    })

export class ATaskShowModalComponent {
  @Input() taskSetting;

  save_command:number = 1;
  sendlisttext:string = "";
  viewTemplate:boolean = false;
  viewTemplateText:string = "見る";
  viewPerson:boolean = false;
  viewPersonText:string = "見る";

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ret:any={
    status:"",
    save_command:'1',
    template_name:""
  }

  ngOnInit(): void {
    if(this.taskSetting.m_event_task_type_id==9){
      this.sendlisttext = "全"+this.taskSetting.person_data.length + "件送信予定<br>";
      for (let i = 0; i < this.taskSetting.person_data.length; i++) {
        this.sendlisttext += this.taskSetting.person_data[i]['name'];
        this.sendlisttext += " < " + this.taskSetting.person_data[i]['mail'] + " > " + "<br>";
      }
    }
  }

  viewTemplateButton(): void {
    this.viewTemplate = !this.viewTemplate;
    if(!this.viewTemplate){
      this.viewTemplateText = "見る";
    }else{
      this.viewTemplateText = "閉じる";
    }
  }
  viewPersonButton(): void {
    this.viewPerson = !this.viewPerson;
    if(!this.viewPerson){
      this.viewPersonText = "見る";
    }else{
      this.viewPersonText = "閉じる";
    }
  }
  modalCloseOK() {
    this.ret.status = 'OK';
    this.activeModal.close(this.ret);
  }
  modalCloseCancel(){
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-mailtask-show-modal.component.ts